import React from 'react';
import { Row, Col } from 'antd';
import ContactForm from '../../form/contact/ContactForm';
import SEO from '../../components/SEO';

const Contact = () => {
    return (
        <div className="contactUsContainer">
            <SEO title="Contact Us" description="One-Stop Transport & Finicial Solution" path="contact" />
            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 6 }}
                    lg={{ span: 6 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                >
                    <h2 className="blockTitle">Get in touch with us..</h2>
                    <br />
                    <ContactForm />
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 9, offset: 2 }}
                    xl={{ span: 9, offset: 2 }}
                    xxl={{ span: 9, offset: 2 }}
                >
                    <h1>Yoma Fleet Limited Head Office </h1>
                    <p>
                        1 Office Park, Rain Tree Drive, Pun Hlaing Estate, Hlaing Thayar Township, Yangon 11401, Myanmar
                    </p>
                    <br />
                    <p>
                        <strong>Hotline numbers - </strong>
                    </p>
                    <p>
                        09 YOMAFLEET (09 966235338)
                        <br /> aung@yomafleet.com
                    </p>
                    <iframe
                        title="Yoma Fleet"
                        className="contactUsMap"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3818.7365448232263!2d96.1019458149376!3d16.839420988409163!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30c19523f6283751%3A0xacd7d6c4a84f3ad3!2sThe%20Campus%3A%20Yoma%20Strategic%20Holdings%20Ltd%2C%20First%20Myanmar%20Investment%2C%20Serge%20Pun%20%26%20Associates!5e0!3m2!1sen!2smm!4v1589890107529!5m2!1sen!2smm"
                    ></iframe>
                </Col>
            </Row>
        </div>
    );
};

export default Contact;
